import { HttpClient } from "@angular/common/http";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DataService } from 'src/app/services/data.service';
import { NavigationService } from '../../../services/navigation.service';;
import { Subscription } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { FilterService } from "src/app/services/filter.service";

@Component({
  selector: "app-grouped-hbar",
  templateUrl: "./grouped-hbar.component.html",
  styleUrls: ["./grouped-hbar.component.scss"],
})
export class GroupedHbarComponent implements OnInit {
  static key = 100603;

  @Input("item") item: any;
  @Input("pageKey") pageKey: any;
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @ViewChild("GroupHBar", { static: true }) GroupHBar!: ElementRef;

  config: any;
  data: any;
  heading: any;
  isDataLoaded = false;
  reqSubcription: Subscription[] = [];
  error_name:any;
  prefrenceConfig:any;
  dashboardKey:any

  constructor(
    private filterService: FilterService,
    private httpClient: HttpClient, 
    private apiService: ApiService,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private dataService: DataService
  ) {
    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        this.loadApiData();
      })
    );
      this.route.queryParams.subscribe((params: any) => {
      let decryptedParams = this.navigationService.decryptData(params);
 
      this.dashboardKey = decryptedParams["ds_key"];
    
    });
  }
  ngOnInit(): void {
    const observer = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observer.observe(this.GroupHBar.nativeElement);
    this.loadlineConfig();
  }

  loadlineConfig() {
    this.heading = this.item.config["report_heading"];
  }

  loadApiData(reportType?: string) {
    let api = this.item.config["list_of_api"] || {};

    if((this.filterService.isEmptyObject(this.filterService.baseQuery) == false)) {
     this.getPreferences();
      // API Payload
      let obj:any = {"api_key" : api}

      let query = Object.assign({}, this.filterService.baseQuery, obj)
      query["report_typ"] = this.filterService.report_type;
      query['module_key'] = this.apiService.getModuleKey();
      let endPoint = this.item.config?.["list_of_api_endpoint"] || '';
      this.reqSubcription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${endPoint || this.apiService.executionUrl}`, query).subscribe((res:any)=> {
          this.isDataLoaded = true;
          this.data = res == null ? [] : res;
          this.error_name = '';
        },(err:any)=>{
          console.log(err)
          this.data = []
          this.isDataLoaded = true;
          this.error_name = err?.error?.error?.message || err?.error?.message || err?.message || '';
        })
      )
      
      // this.reqSubcription.push(this.filterService.executeQuery(obj).subscribe((res: any) => {
      //   this.isDataLoaded = true;
      //   this.data = res == null ? [] : res;
      // },(error: any) => {
      //   this.data = [];
      //   console.log(error)
      // }));
    }
  }
   getPreferences() {
    if(this.item?.widget_uniq_key) {
      let obj = {
        dashboard_key: this.dashboardKey,
        page_name:this.item.config["report_heading"],
        page_key: this.pageKey,
        widget_uinique_key: this.item?.widget_uniq_key,
        employee_key: this.filterService.baseQuery?.employee_key || 0
      }
      this.dataService.getPreference(obj).subscribe((res:any) => {
        if(res && res.length) {
          let value = res?.[0]?.preference_value ? JSON.parse(res?.[0]?.preference_value) : '';
          this.prefrenceConfig = value;
        }
      })
    }
  }
  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }
}
